// extracted by mini-css-extract-plugin
export default {"infoList":"valuedescriptionlist_infoList__Nm5Hz"};